<nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white">
  <div class="container-fluid">

    <!-- Toggler -->
    <button class="navbar-toggler" type="button" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="isCollapsed"
      aria-controls="sidebarCollapse" aria-expanded="true" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Brand -->
    <a class="navbar-brand" routerLink="/frame/dashboard">
      <img src=logoURL class="navbar-brand-img mx-auto" alt="IQ Water System" id="brandImage">
    </a>


    <!-- Collapse -->
    <div class="collapse navbar-collapse" id="sidebarCollapse" [ngbCollapse]="isCollapsed">

      <!-- Navigation -->
      <ul class="navbar-nav">

        <!-- @insert_generated_views -->


        <li class="nav-item">
          <a class="nav-link" routerLink="/frame/dashboards">
            <i class="fe fe-rss"></i> Cockpit
          </a>
        </li>


        <li *ngIf="user.IsPlatformAdmin" class="nav-item">
          <a class="nav-link" routerLink="/frame/alarm-settings">
            <i class="fe fe-sliders"></i> Einstellungen
          </a>
        </li>

        <li *ngIf="user.IsPlatformAdmin" class="nav-item">
          <a class="nav-link" routerLink="/frame/access-management">
            <i class="fe fe-users"></i> Zugriffsrechte
          </a>
        </li>

        <li *ngIf="user.IsPlatformAdmin" class="nav-item">
          <a class="nav-link" routerLink="/frame/documentation" target="_blank">
            <i class="fe fe-help-circle"></i> Hilfe
          </a>
        </li>

      </ul>

      <div class="navbar-user mt-auto  d-md-flex">
        <hr />
      </div>


      <!-- User (md) -->
      <div class="navbar-user mt-auto  d-md-flex">

        <a class="text-muted" routerLink="/frame/settings">
          <span class="icon">
            <i class="fe fe-settings"></i>
          </span>
        </a>

        <div>
          <a>
            <scfe-user-circle [user]="user"></scfe-user-circle>
          </a>
        </div>

        <!-- <a (click)="onClickOpenNotification()" class="text-muted" href="javascript:void(0);">
          <span class="icon">
            <i class="fe fe-bell mr-2" style="font-size: 20px"></i>
          </span>
        </a> -->

        <!-- Icon -->
        <a class="text-muted" (click)="logout()">
          <span class="icon">
            <i class="fe fe-log-out"></i>
          </span>
        </a>

      </div>


    </div> <!-- / .navbar-collapse -->

  </div> <!-- / .container-fluid -->
</nav>


<!-- Notification modal -->
<ng-template #notificationModal let-c="close" let-d="dismiss">

  <div class="modal-header">
    <h2 class="modal-title">Aufmerksamkeit bitte</h2>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <div *ngIf="!hasNotifications">
          <p>Derzeit liegen keine aktiven Alarme oder Meldungen vor</p>
        </div>

        <!-- Alarm notifications -->
        <div *ngIf="hasNotifications && notifications && notifications.length" class="table-responsive">
          <div class="col-12">
            <h4>Erkennung von Mikroleckagen</h4>
            <hr />
          </div>
          <table class="table">
            <thead>
              <th>Datum</th>
              <th>Meldung</th>
            </thead>
            <tbody>
              <tr *ngFor="let n of notifications" class="bg-white">
                <td placement="top" container="body" ngbTooltip="{{n.Timestamp | dateFormat }}">
                  {{n.Timestamp | humanizedDate }}
                </td>
                <td>{{ n.Content }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Normal notifications -->
        <div *ngIf="hasNotifications && userNotifications && userNotifications.length" class="table-responsive">
          <div class="col-12">
            <h4>Benachrichtigungen</h4>
            <hr />
          </div>
          <table class="table">
            <thead>
              <th>Datum</th>
              <th>Botschaft</th>
            </thead>
            <tbody>
              <tr *ngFor="let n of userNotifications" class="bg-white">
                <td placement="top" container="body" ngbTooltip="{{n.Timestamp | dateFormat }}">
                  {{n.Timestamp | humanizedDate }}
                </td>
                <td>{{ n.Content }}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-primary" (click)="d('Cross click')">Okay</button>
  </div>

</ng-template>